class LoginService {
  constructor ($q, $http, ngAuthSettings, $httpParamSerializerJQLike) {
    this.$q = $q;
    this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
  }

  login(user, pass) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/login/user-login',
        data: this.$httpParamSerializerJQLike({'username': user, 'password': pass}),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  logout (){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.userLogout,
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  setOperatingCenter(branchId){
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setClientOperatingCenter,
        data: this.$httpParamSerializerJQLike({ 'operatingCenterId': branchId }),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  registerUser(userData) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/terceros/terceros/create',
        data: userData,
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }

  resetPassword(user) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/login/recover-password',
        data:  this.$httpParamSerializerJQLike({'email': user}),
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        cache : false
      }).then(function (response) {
        resolve(response.data);
      }, function (reason) {
        reject(reason);
      });
    });
  }
}

LoginService.$inject = ['$q','$http', 'ngAuthSettings', '$httpParamSerializerJQLike'];

export default LoginService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/login/login.service.js
 **/